/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_appsync_graphqlEndpoint": "https://kqlr4cnwa5ag5lj3hcznuiufuy.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-r4wjosy5r5emtbzizxivljbn5i",
    "aws_cloud_logic_custom": [
        {
            "name": "notificationsApi",
            "endpoint": "https://7uacstuhbh.execute-api.eu-central-1.amazonaws.com/qa",
            "region": "eu-central-1"
        },
        {
            "name": "middlewareREST",
            "endpoint": "https://m7zjsshor0.execute-api.eu-central-1.amazonaws.com/qa",
            "region": "eu-central-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-central-1:c00ab9e0-4a57-4efb-a1d3-913f3a4b8d39",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_O2vxTq67D",
    "aws_user_pools_web_client_id": "5vi2akro8g34p2c9qnbsv4kvu",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "labouronnect-20200228115848-hostingbucket-qa",
    "aws_content_delivery_bucket_region": "eu-central-1",
    "aws_content_delivery_url": "http://labouronnect-20200228115848-hostingbucket-qa.s3-website.eu-central-1.amazonaws.com",
    "aws_user_files_s3_bucket": "labourtech-case-documents92940-qa",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
